import { Text } from '@rbilabs/universal-components';

export const StyledText = Text.withConfig({
  fontSize: '2xl',
  lineHeight: '2xl',
  marginY: '0',
  marginX: 'auto',
  fontWeight: 'semibold',
  textAlign: 'center',
});
